<template>
  <a-row class="assessment">
    <a-col :span="12">
      <div class="echartRadar">
        <div class="explainWrap">
          <span>专利价值度:{{ patentValue }}</span>
          <a-tooltip overlayClassName="tooltipsClass" placement="right">
            <my-icon
              class="my-icon assessment-icon-help"
              type="icon-help"
            ></my-icon>
            <template slot="title">
              <span>
                专利价值度是奥凯大数据中心独创的专利评价指标，用于评估专利的价值。奥凯大数据中心基于深度加工的专利数据，采用复合指标算法结合机器学习模型进行价值估算，通过多维度结合，整合出专利价值评估数值。
                专利价值度评估数值区间为0~100。专利价值度可帮助用户从海量的专利数据中快速有效地筛选出核心专利，优先阅读和分析核心专利，有效提高工作效率和质量。
              </span>
            </template>
          </a-tooltip>
        </div>
        <!-- <div id="chart1" style="width:100%; height: 500px;"></div> -->
      </div>
    </a-col>
    <!-- <a-col :span="12">
      <ResultTableInfo></ResultTableInfo>
    </a-col> -->
  </a-row>
</template>

<script>
// import ResultTableInfo from './ResultTableInfo.vue'
import { searchParams } from './config'
import { querySearch } from '@/api/competitor'
export default {
  props: {
    publicNum: String
  },
  data() {
    return {
      searchParams,
      patentValue: 0
    }
  },
  components: {
    // ResultTableInfo
  },
  mounted() {
    this.initEChar()
  },
  methods: {
    async initEChar() {
      const searchExp = `(公开号=${this.publicNum})`
      this.searchParams.searchExpre = searchExp
      const { data } = await querySearch({ ...this.searchParams })
      const result = JSON.parse(data).result[0]
      console.log(result, 'result');
      this.patentValue = result.patent_value_score
      // const seriesValue = ['high_quality_score', 'high_technical_score', 'development_score', 'high_economy_score'].reduce((pre, curKey) => {
      //   const v = result[curKey]
      //   pre.push(v)
      //   return pre
      // }, [])
      //指定图标的配置和数据
      // var option = {
      //   tooltip: {},
      //   legend: { },
      //   radar: {
      //     radius: '70%',
      //     indicator: [{name:'高专利质量', max: 100},{name:'高技术性', max: 100},{name:'发展前景', max: 100},{name:'高经济性', max: 100}],
      //     name: {
      //       formatter: '{value}',
      //       textStyle: {
      //         color: '#b2b4c2' // 文字颜色
      //       }
      //     }
      //   },
      //   series: [{
      //     name: '专利价值',
      //     type: 'radar',
      //     data: [
      //       {
      //         value:seriesValue,
      //         lineStyle: {
      //           color: '#2279d2'
      //         }
      //       }
      //     ]
      //   }]
      // };
      // //初始化echarts实例
      // var myChart = echarts.init(document.getElementById('chart1'));
      // //使用制定的配置项和数据显示图表
      // myChart.setOption(option);
    }
  }
}
</script>
